import { Injectable } from '@angular/core';
import { ContentfulApiService } from './contentful-api.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: "root",
})
export class CounterApiService {
    private readonly ContentTypeId = "Counter";

    constructor(private contentfulApiService: ContentfulApiService) {}

    async generateSubscriptionId(): Promise<string> {
        const counterId = environment.contentful.counterId;

        const counter = await this.contentfulApiService.getEntry(counterId);
        const current = counter.fields.lastNumber["en-US"] as number;
        const incrementAleatoire = Math.floor(Math.random() * 100) + 1;
        const next = current + incrementAleatoire;
        
        const padded = next.toString().padStart(4, "0");
        const year = counter.fields.year["en-US"];

        counter.fields.lastNumber["en-US"] = next;
        const updatedCounter = await counter.update();
        await updatedCounter.publish();

        return `DA_${year}_${padded}`;
    }
}
